import { _ as _object_without_properties_loose, a as _extends } from './cc-CWi2JB6O.js';
import { jsx } from 'react/jsx-runtime';
import { SITE_URL_PRODUCTION } from '@repo/constants';
import NextLink from 'next/link';

function sanitiseHref(href) {
    let newHref = href;
    newHref = newHref.replace("shop.", "");
    newHref = newHref.replace(`${SITE_URL_PRODUCTION}/`, "/");
    return newHref;
}
function Link(_param) {
    var { href } = _param, rest = _object_without_properties_loose(_param, [
        "href"
    ]);
    if (typeof href === "object" && "pathname" in href && href.pathname) {
        const sanitisedHref = href;
        sanitisedHref.pathname = sanitiseHref(href.pathname);
        return /*#__PURE__*/ jsx(NextLink, _extends({}, rest, {
            href: sanitisedHref
        }));
    } else if (typeof href === "string") {
        const sanitisedHref = sanitiseHref(href);
        return /*#__PURE__*/ jsx(NextLink, _extends({}, rest, {
            href: sanitisedHref
        }));
    }
}

export { Link, sanitiseHref };
